import { render, staticRenderFns } from "./TemplatesContainer.vue?vue&type=template&id=6b5f3510&scoped=true&"
import script from "./TemplatesContainer.vue?vue&type=script&lang=js&"
export * from "./TemplatesContainer.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesContainer.vue?vue&type=style&index=0&id=6b5f3510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f3510",
  null
  
)

export default component.exports